import type * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const statusPillVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium",
  {
    variants: {
      status: {
        ok: "bg-domain-energy-wash text-domain-energy-foreground",
        info: "bg-domain-climate-wash text-domain-climate-foreground",
        warn: "bg-domain-light-wash text-domain-light-foreground",
        alert: "bg-domain-security-wash text-domain-security-foreground",
        offline: "bg-muted text-muted-foreground",
      },
    },
    defaultVariants: { status: "ok" },
  },
);

const dotColor: Record<NonNullable<VariantProps<typeof statusPillVariants>["status"]>, string> = {
  ok: "bg-domain-energy",
  info: "bg-domain-climate",
  warn: "bg-domain-light",
  alert: "bg-domain-security animate-pulse",
  offline: "bg-muted-foreground",
};

export function StatusPill({
  className,
  status = "ok",
  children,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof statusPillVariants>) {
  return (
    <span
      data-slot="status-pill"
      className={cn(statusPillVariants({ status }), className)}
      {...props}
    >
      <span className={cn("size-1.5 rounded-full", dotColor[status ?? "ok"])} />
      {children}
    </span>
  );
}
